module.exports = __webpack_public_path__ + "static/northstar_blue-0fe3d0e9c918c059d854e4a4d773f199.png";